function SecurityPaymentPreview() {
  return (
    <section className="security-payment-preview">
      <div className="security-payment-content">
        <div className="security-payment-left">
          {/* Row 1: Title */}
          <h2 className="security-payment-title">Security & Payments</h2>
          
          {/* Row 2: List Container */}
          <div className="security-payment-list">
            <div className="security-payment-list-item">
              <img 
                src={`${process.env.PUBLIC_URL}/images/icons/verified_gray.svg`} 
                alt="" 
                className="security-payment-icon" 
              />
              <span>Secure document handling</span>
            </div>
            <div className="security-payment-list-item">
              <img 
                src={`${process.env.PUBLIC_URL}/images/icons/verified_gray.svg`} 
                alt="" 
                className="security-payment-icon" 
              />
              <span>Trusted payment processing (Powered by Stripe)</span>
            </div>
            <div className="security-payment-list-item">
              <img 
                src={`${process.env.PUBLIC_URL}/images/icons/verified_gray.svg`} 
                alt="" 
                className="security-payment-icon" 
              />
              <span>Funds are released only after work is completed and approved</span>
            </div>
          </div>
        </div>
        <div className="security-payment-right">
          <img 
            src={`${process.env.PUBLIC_URL}/images/secure_stripe.svg`} 
            alt="Secure payments with Stripe" 
            className="security-payment-image"
          />
        </div>
      </div>
    </section>
  );
}

export default SecurityPaymentPreview;

